import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import './assets/styles/index.scss';
import Spinner from './common/components/base/spinner/spinner';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import PullToRefresh from 'common/components/pull-to-refresh/pull-to-refresh';
dayjs.extend(isBetween);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
    <PullToRefresh />
    <Spinner />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
